import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ArticleHeaderDefault } from "./variants/ArticleHeaderDefault";
export type ArticleHeaderVariant = "default";
export interface ArticleHeaderProps {
  /** The variant of the article header to render */
  variant?: ArticleHeaderVariant;
}

/**
 * Header components for each variant.
 * These are purely presentational and receive data through context.
 */
const VARIANT_COMPONENTS: Record<ArticleHeaderVariant, React.ComponentType> = {
  default: ArticleHeaderDefault
};

/**
 * ArticleHeader component with support for different variants.
 *
 * Usage:
 * ```tsx
 * <ArticleHeader variant="default" />
 * ```
 */
export function ArticleHeader(t0) {
  const $ = _c(2);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const HeaderComponent = VARIANT_COMPONENTS[variant];
  let t2;
  if ($[0] !== HeaderComponent) {
    t2 = <HeaderComponent />;
    $[0] = HeaderComponent;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}